import React, { useContext, useEffect } from "react";
import "./style.css";
import axios from "axios";
import moment from "moment";
import { Markup } from "interweave";
import { useState } from "react";

import { Card } from "react-bootstrap";
import { CardContent } from "@material-ui/core";
import RegisterNowPay from "../../../components/RegisterLearningDetails/RegisterNowPay/RegisterNowPay";
import swal from "sweetalert";
import ReactShowMoreText from "react-show-more-text";
import { LocationContext } from "../../../CustomHelper/Helper";
import Navigation from "../../Layouts/Header/Navigation";
import { serverInfo } from "../../../App";
import ContentLoader from "../../../Screen/ContentLoader";

const GreetingRegistration = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [post, setPost] = useState({});
  const [postRegistration, setPostRegistration] = useState({});
  const [loading, setloading] = useState(true);

  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  const [inputData, setInputData] = useState({
    name: "",
    greeting_context: "",
    additional_message: "",
    error_list: [],
  });

  const getPrimaryData = (greeting_id) => {
    axios
      .get(`/api/user/greeting-info-to_registration/${greeting_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setPost(res.data.greeting);
          setPostRegistration(res.data.greetingsRegistration);
          setloading(false);
        }
      });
  };

  useEffect(() => {
    const greeting_id = props.match.params.greeting_id;
    getPrimaryData(greeting_id);
  }, [props.match.params.greeting_id]);
  // normal Input
  const handleInput = (e) => {
    e.persist();
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const greetingSubmit = (e) => {
    e.preventDefault();

    const fData = new FormData();
    fData.append("name", inputData.name);
    fData.append("greeting_context", inputData.greeting_context);
    fData.append("additional_message", inputData.additional_message);
    fData.append("greeting_registration_id", postRegistration.id);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post("/api/user/greetings_registaion_update", fData).then((res) => {
        if (res.data.status === 200) {
          getPrimaryData(post.id);
        } else if (res.data.status === 422) {
          setInputData({
            ...inputData,
            error_list: res.data.validation_errors,
          });
        } else {
          swal("error", "Network error", "error");
        }
      });
    });
  };

  return (
    <>
      <Navigation />
      {loading === true ? (
        <ContentLoader />
      ) : (
        <>
          <div className="container">
            <div className="mt-3 card card-bg1 p-2">
              <img
                src={imageCdnUrl + post.banner}
                className="img-fluid w-100 "
                alt={imageCdnUrl + post.banner}
              />
            </div>

            <Card
              className="my-4"
              style={{ backgroundColor: "#25272b" }}
              sx={{ minWidth: 275 }}
            >
              <CardContent>
                <div className="row whole-m-p">
                  <h4 className="starChat-heading">{post.title}</h4>
                  <div className="vb"></div>

                  <div className="mt-3 row">
                    <div className="col-md-6 display-style-starChat">
                      <div className="me-5 starChat-child-style text-white">
                        <h6>Star</h6>
                        <h6>Date</h6>
                        <h6>Time</h6>
                        <h6>Fee</h6>
                        <h6>Purpose</h6>
                      </div>

                      <div
                        style={{ color: "#c2c2c2" }}
                        className="mx-5 starChat-child-style"
                      >
                        <h6>
                          {post.star?.first_name} {post.star?.last_name}
                        </h6>
                        <h6>
                          {moment(postRegistration.request_time).format(
                            "D MMMM YYYY"
                          )}
                        </h6>
                        <h6>
                          {moment(postRegistration.request_time).format(
                            "hh:mm A"
                          )}
                        </h6>
                        <h6>{paymentCountWithSymbol(post.cost)}</h6>
                        <h6>{postRegistration.purpose}</h6>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mx-2 starChat-child-style">
                        <h5 className="text-white">Greeting Instruction</h5>

                        <ReactShowMoreText
                          lines={3}
                          more={<span>See more</span>}
                          less={<span>See less</span>}
                          className="text-light"
                          anchorClass="my-anchor-css-class"
                          expanded={false}
                          truncatedEndingComponent={"... "}
                        >
                          <Markup content={post.instruction}></Markup>
                        </ReactShowMoreText>
                      </div>
                    </div>
                  </div>
                </div>

                {postRegistration.payment_status === null ? (
                  postRegistration.name === null ||
                  postRegistration.greeting_context === null ? (
                    <div className="guitarBorder">
                      <div className="card-body">
                        <form
                          onSubmit={greetingSubmit}
                          id="input_form"
                          encType="multipart/form-data"
                        >
                          <div className="row my-4">
                            <div className="col-md-2 text-white">
                              <p>
                                <big>Name of person</big>
                              </p>
                            </div>
                            <div className="col-md-10">
                              <input
                                style={{ color: "#ffffff" }}
                                className="form-control input-gray"
                                type="text"
                                onChange={handleInput}
                                name="name"
                                value={inputData.name}
                                placeholder="Name of person"
                              />
                              <span className="text-danger">
                                {inputData.error_list.name}
                              </span>
                            </div>
                          </div>
                          <div className="row my-4">
                            <div className="col-md-2 text-white">
                              <p>
                                <big>Greeting context </big>
                              </p>
                            </div>
                            <div className="col-md-10">
                              <textarea
                                rows="8"
                                cols=""
                                name="greeting_context"
                                style={{ color: "#ffffff" }}
                                value={inputData.greeting_context}
                                className="w-100 PostTextM p-2"
                                onChange={handleInput}
                                placeholder="Greeting context"
                              ></textarea>
                              <span className="text-danger">
                                {inputData.error_list.greeting_context}
                              </span>
                            </div>
                          </div>
                          <div className="row my-4">
                            <div className="col-md-2 text-white">
                              <p>
                                <big>Additional message</big>
                              </p>
                            </div>
                            <div className="col-md-10">
                              <textarea
                                rows="8"
                                cols=""
                                name="additional_message"
                                style={{ color: "#ffffff" }}
                                value={inputData.additional_message}
                                className="w-100 PostTextM p-2"
                                onChange={handleInput}
                                placeholder="Additional Message"
                              ></textarea>
                              <span className="text-danger">
                                {inputData.error_list.additional_message}
                              </span>
                            </div>
                          </div>
                          <div className="my-3 text-center">
                            <button type="submit" className="btn btn-warning ">
                              Save
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  ) : (
                    <RegisterNowPay
                      post={post}
                      event_type="greeting"
                      fee={paymentCount(post.cost)}
                      baseFee={post?.cost}
                      postRegistration={postRegistration}
                      notification_id={parseInt(
                        props.match.params.notification_id
                      )}
                      greetingId={props.match.params.greeting_id}
                    />
                  )
                ) : (
                  <>
                    <div className="guitarBorder">
                      <div className="card-body">
                        <div className=" text-white d-flex justify-content-center align-items-center">
                          <big className="text-center">Already Registered</big>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </CardContent>
            </Card>
          </div>
        </>
      )}
    </>
  );
};

export default GreetingRegistration;
